<template>
<div>
    <Spinner v-if="loading" class="mt-5"> {{ loadingMessage}}</Spinner>

    <div v-else>
        <div v-if="isMpgs" class="row">
            <!--================================ SHOW SAVE CARDS====================== -->
            <div v-if="!showCardInput">

                <div v-if="!redirect_to_third_party">
                    <SavedCards v-if="show_select_card" :cards="cards" @triggerManageCard="triggerManageCard"  @makePayment="makePayment" @selectCard="selectCard" @triggerCardInput="triggerCardInput" />
                </div>
                <div v-else class="text-center">
                    <p class="mb-3" style="margin-top:70px;">You will be redirected to your card's issuer's verification page to authorize this payment.</p>
                    <!-- <button type="submit" class="viabutton submit mb-3" @click.prevent="visitThirdParty">Proceed</button>
                    <a href="javascript:void(0)" class="change-option" @click.prevent="cancelRedirect"> Cancel </a> -->
                </div>
                <!--================================ SHOW SAVE CARDS====================== -->

                <!--================================ SHOW MANAGE CARDS ====================== -->
                <ManageCard v-if="show_manage_card" :attemptCardRemoval="attemptCardRemoval" :cards="cards" @pickCardToDelete="pickCardToDelete"  @handleAttemptCardRemoval="handleAttemptCardRemoval" @gotoCardListing="gotoCardListing" @removeCard="removeCard" @cancelCardRemoval="cancelCardRemoval"  @triggerPayment="triggerPayment"  :mpgsSdkUrl="mpgsSdkUrl" />
                <!--================================ SHOW MANAGE CARDS ====================== -->
            </div>
            <!--================================ SAVED CARDS====================== -->

            <!--================================ SHOW MPGS  CARD INPUT ========================== -->
            <MpgsCardInput v-else :scriptLoaded="scriptLoaded" :redirectToThirdParty="redirect_to_third_party"  :extras="provider.extras" @isLoading="handleIsLoading"  @callOnePipe="callOnePipe"  @triggerPayment="triggerPayment" :button_color="button_color" :mpgsSdkUrl="mpgsSdkUrl"  />
            <!--================================ SHOW MPGS CARD INPUT ========================== -->
        </div>

        <CardInput v-else  :isLoading="handleIsLoading"  />

    </div>
</div>
</template>

<script>
import SavedCards from './includes/SavedCards.vue'
import MpgsCardInput from './includes/MpgsCardInput.vue'
import CardInput from './includes/CardInput.vue'
/* eslint-disable */

import axios from 'axios';
import Spinner from './includes/Spinner.vue'
import {
    EventBus
} from './includes/bus.js';


export default {
    name: 'CardPayment',
    props: ['appColor', 'data', 'client_info', 'button_color'],
    components: {
        Spinner, CardInput, MpgsCardInput, SavedCards
    },
    watch: {
        loading(val) {
            if (!val) {
                this.$emit('hideBack', true)
            } else {
                this.$emit('hideBack', false)
            }

        },
        show_select_card (val){
            if(val){
                this.$emit('modalTop', 'mpgs-card-top')
            }else{
                this.$emit('modalTop', 'default')
            }
        },

        show_select_card (val){
            if(val){
                this.$emit('modalTop', 'mpgs-card-top')
            }
        }
    },

    
    mounted() {

        if (this.data.details.source && this.data.details.source == 'iframeReply') { // Coming from 3D Secure Page

            // Pick the reference and call OnePipe
            this.provider = this.data.details.iframereply.provider;
            this.redirect_returning_data = this.data.details.iframereply
            this.validate3DS_Transaction(`${this.redirect_returning_data.redirect_content};${this.redirect_returning_data.data.response_gatewayRecommendation || ''};${this.redirect_returning_data.data.result || ''}`); // token or ession ID here..


        }else{

             if (!this.loading) {
                this.ccBorderColor = this.appColor;
            }

            this.handleGlobalBack();

            if (this.data.details.action != null && this.data.details.action[0].provider != null){
                this.provider = this.data.details.action[0];
                this.$store.dispatch('provider', this.provider);

                if (this.provider.provider.toLowerCase() == "mpgs") {
                    this.loading = this.isMpgs = true;
                    this.lookUpTokens();
                } else {
                    this.loading = false;
                    this.showCardInput = true;
                }
            }
        }

    },
    data() {
        return {
            // provider:'',
            show_manage_card: false,
            show_select_card: false,
            card_index: null,
            delete_card_index: null,
            attemptCardRemoval: false,
            attemptCardRemovalCardKey: null,
            cardToBeRemoved: {},
            isVerve: false,
            loading: false,
            getPin: false,
            isCallingOnePipe: false,
            
            removeMargin: false,
            borderColor: '#e4e4e4',
            isMpgs: false,
            mpgsIsReady: false,
            tokenize: false,
            showCardInput: false,
            session_id: '',
            token: '',
            mpgsSdkUrl: '',
            cards: [],
            hoverKey: 0,
            hoverValue: '',
            hover: false,
            cardRemovalActionHover: '',
            cardRemovalActionHoverKey: '',
            provider: {},
            scriptLoaded: null,
            selected_card: null,
            loadingMessage: 'Loading..',
            removalMessage: '',
            removalMessageStyle: {
                'color': '#3c763d',
                'background-color': '#dff0d8',
                'border-color': '#d6e9c6',
                'color': '#a94442',
                'background-color': '#f2dede',
                'border-color': '#ebccd1',
                'padding': '5px',
                'margin-bottom': '20px',
                'border': '1px solid transparent',
                'border-radius': '4px',
                'text-align': 'center',
            },
            iframe_html_content : '',
            redirect_to_third_party: false,
            initial_redirect_data: '',
            redirect_returning_data: '',
            countDownSeconds: 3,
        }
    },
    methods: {
        handleIsLoading(val){
            this.loading = val
        },

        handleGlobalBack(){
            EventBus.$on('global-back', payload => {
                
                if (payload.in_view.toLowerCase() == 'cardpayment' && payload.action == "back") {
                    if (this.show_select_card) {
                        this.changePaymentOption();
                        if(window.countDown)
                            clearInterval(window.countDown);
                    } else {
                        if(this.redirect_to_third_party){
                            this.cancelRedirect();

                        }else if(this.show_manage_card){
                            if(this.cards.length > 0){
                                this.$emit('handleTitle', this.data.details.title);
                                this.$emit('handleCss', 'cardmaster master');
                                this.show_select_card = true;
                                this.showCardInput = false;
                                this.show_manage_card= false;
                            }else{
                                this.changePaymentOption();
                            }
                        }
                        else if(this.showCardInput){
                            this.mpgsIsReady = false;
                            if(this.cards.length > 0){
                                this.$emit('handleTitle', this.data.details.title);
                                this.$emit('handleCss', 'cardmaster master');
                                this.show_select_card = true;
                                this.show_manage_card= false;
                                this.showCardInput = false;
                            }else{
                                this.changePaymentOption();
                            }
                        }
                    }
                }
            });
        },

        pickCard(card) {
            this.selected_card = card
        },
        pickCardToDelete(card) {
            this.selected_card = card
        },
        
        makePayment() {
            const card = this.selected_card;
            this.$store.dispatch('mPGSCardUsed', card);
            // this.$store.dispatch('paymentProvider', 'MPGS');
            this.callOnePipe(card.uid);
        },

        changePaymentOption() {
            this.mpgsIsReady = false;
            this.$parent.changeComponent("PaymentOptions");
        },

        loadScript(callback) {

            let base_url = this.provider.extras.api_base_url,
                href = `${base_url}/form/version/${this.provider.extras.version || 57}/merchant/${this.provider.extras.merchant}/session.js`;
            this.mpgsSdkUrl = href;
            // console.log(href);

            let el = document.querySelector(`script[src='${href}']`);

            if (document.querySelector("script[src='" + href + "']")) {
                return;
            }
            const script = document.createElement('script');
            script.setAttribute('src', href);
            script.setAttribute('type', "text/javascript");
            document.head.appendChild(script);
            if (script.readyState) { // IE
                script.onreadystatechange = () => {
                    if (script.readyState === "loaded" || script.readyState === "complete") {
                        script.onreadystatechange = null;
                        callback();
                    }
                };
            } else { // Others
                script.onload = () => {
                    callback();
                };
            }
        },

        

        
        hoverEffect(value, key) {
            this.hover = value
            this.hoverKey = key
        },

        cardRemovalHoverEffect(value, key) {
            this.cardRemovalActionHover = value
            this.cardRemovalActionHoverKey = key
        },        

        triggerCardInput() {
            
            this.$emit('handleTitle', 'Add New Card');
            this.$emit('handleCss', '');

            this.showCardInput = true;
            this.show_manage_card = false;
            this.show_select_card = false;
            this.scriptLoaded = new Promise(resolve => {
                this.loadScript(() => {
                    resolve();
                });
            });

            this.integration();
        },

        triggerManageCard() {
            this.$emit('handleTitle', 'Manage Existing Card');
            this.$emit('handleCss', 'cardmaster')
            this.showCardInput = false;
            this.show_select_card = false;
            this.show_manage_card = true;
        },

        triggerPayment() {
            PaymentSession.updateSessionFromForm('card');
        },
        
        callOnePipe(session) {


            this.loading = true;
            
            if(Object.keys(this.provider.extras).includes('enable_3dsecure') && this.provider.extras.enable_3dsecure != null && this.provider.extras.enable_3dsecure.toLowerCase() === 'true'){
                this.loadingMessage = 'Initializing Payment...';
            }else{
                this.loadingMessage = 'Making Payment...';
            }

            /* 
                This is an hack to get value of the tokenized checked box
                I didn't use v-model becuase, it usually unmount the mounted Mastercard Payment field
            */

            if (session == "" && session.length < 0) {
                // Can't call OnePipe show error
                this.errors.card_cc = "Fill card details correctly";
                this.isCallingOnePipe = this.loading = false;
                this.loadingMessage = '';

                return
            }

            if (document.getElementById('tokenize-card')) {
                let elem = document.getElementById('tokenize-card');
                if (elem.checked)
                    this.tokenize = true;
                else
                    this.tokenize = false;
            }

            // if enforce tokenize is true
            if (this.enforce_tokenization && this.showCardInput) {
                this.tokenize = true;
            }

            try {
                let initialPayload = this.$store.state.payload;

                let payload = {
                    request_ref: initialPayload.request_ref,
                    request_type: initialPayload.request_type,
                    auth: {
                        "type": "custom",
                        "secure": session,
                        "auth_provider": "MPGS",
                    },
                    transaction: initialPayload.transaction

                }

                // Check if the transaction.details is available 
                if (Object.keys(payload.transaction).includes('details') && payload.transaction.details != null) {
                    payload.transaction.details.tokenize = this.tokenize;
                } else {
                    payload.transaction.details = {
                        tokenize: this.tokenize
                    }
                }

                // check if the user is trying again, update the transaction ref
                payload.transaction.transaction_ref = this.$store.state.transRef
                if (this.$store.state.isFailed)
                    payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

                let data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'transact',
                    payload: payload
                }
                let data = this.$generateToken(data2);

                axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    Authorization: 'Bearer ' + this.$store.state.payload.api_key
                }).then((response) => {
                    this.loading = false;
                    this.loadingMessage = 'Loading..';
                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                    window.raw = JSON.stringify(res);

                    // console.log(res);

                    // Go and do the auto close popup on the status page instead of every pages.. it's more descent that way
                    if (status == "successful") {
                        
                        if(Object.keys(responseData).includes('provider_response') && responseData.provider_response !== null){
                            if(Object.keys(responseData.provider_response).includes('meta') && responseData.provider_response.meta !== null){
                                if(Object.keys(responseData.provider_response.meta).includes('source_of_funds') && responseData.provider_response.meta.source_of_funds !== null){
                                    if(Object.keys(responseData.provider_response.meta.source_of_funds).includes('provided') && responseData.provider_response.meta.source_of_funds.provided !== null){
                                        if(Object.keys(responseData.provider_response.meta.source_of_funds.provided).includes('card') && responseData.provider_response.meta.source_of_funds.provided.card !== null){
                                            const cardUsed = responseData.provider_response.meta.source_of_funds.provided.card;
                                            // Check the the card respsone is present
                                            this.$store.dispatch('mPGSCardUsed', cardUsed);
                                            this.$store.dispatch('paymentMethodProvider', 'MPGS');
                                        }
                                    }
                                }
                            }
                        }
                        
                        
                        this.loading = false;
                        this.$parent.changeComponent('Status', {
                            reference: payload.transaction.transaction_ref,
                            type: 'Successful',
                            data: responseData,
                            message: message || res.data.message
                        });
                    } else if (status === "pendingvalidation") {

                        this.isLoading = false;
                        this.iframe_html_content = responseData.provider_response.html_content;
                        this.redirect_to_third_party = true;
                        this.initial_redirect_data = {
                            'status': 'redirect',
                            'data': {
                                'transaction': this.transaction,
                                'redirectUrl': window.location.hostname === 'localhost' ?
                                    'http://redirect.md/' : this.provider.custom_ui_url,
                                "callback_url": window.location.hostname === 'localhost' ?
                                    'http://redirect.md/' : this.provider.extras.callback_url,
                                'chargeUrl': data.iframeUrl,
                                'sourceUrl': window.location.hostname === 'localhost' ?
                                    'http://onepipejs.md/inline-v2.min.js' : 'https://js.dev.onepipe.io/v2', //window.parent.location.href,
                                'provider': this.provider,
                                'iframe_html_content' : this.iframe_html_content,
                                'redirect_type' : responseData.provider_response.redirect_type,
                                'redirect_content' : responseData.provider_response.redirect_content,
                            }
                        }

                        // start countdown in 5 secs
                        setTimeout(() => {
                            this.timeoutCountdown();
                        }, 1000);

                    } else {
                        window.failedFromStart = false;
                        window.failedFromStartMessage = message || "Payment Failed."
                        this.$router.push('/v2/mtn/warning');
                    }
                }).catch(err => {
                    console.log(err)
                    window.raw = JSON.stringify(err);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = err;
                    this.$router.push('/v2/mtn/warning');
                })
            } catch (err) {
                console.log(`Call OnePipe Error ${err}`)
                window.raw = JSON.stringify(err);
                window.failedFromStart = false;
                window.failedFromStartMessage = err;
                this.$router.push('/v2/mtn/warning');
            }
        },

        lookUpTokens() {
            try {
                this.loadingMessage = 'Fetching cards..';
                let initialPayload = this.$store.state.payload;

                let payload = {
                    request_ref: this.$generateRequestRef(),
                    request_type: 'lookup_cards',
                    auth: {
                        "type": "custom",
                        "secure": initialPayload.transaction.customer.customer_ref,
                        "auth_provider": "MPGS",
                    },
                    transaction: {
                        transaction_ref: this.$generateTransactionRef(),
                        transaction_ref_parent: "",
                        customer: initialPayload.transaction.customer
                    }
                }

                let data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'transact',
                    payload: payload
                }
                let data = this.$generateToken(data2);

                axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    Authorization: 'Bearer ' + this.$store.state.payload.api_key
                }).then((response) => {
                    this.loadingMessage = '';
                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                    window.raw = JSON.stringify(res);

                    if (response.status == 200) {
                        this.showCardInput = true;

                        if (status == "successful") {
                            this.loading = false;

                            if (responseData.provider_response.cards.length > 0) {
                                this.$emit('handleCss', 'cardmaster master');
                                this.showCardInput = false;
                                this.show_select_card = true;
                                this.cards = responseData.provider_response.cards;
                            } else {
                                this.$emit('handleTitle', 'Add New Card');
                                this.$emit('handleCss', '');
                                this.showCardInput = true;

                                setTimeout(() => {
                                    this.loading = false;
                                    this.triggerCardInput();
                                    this.integration();
                                }, 1000);
                            }
                        } else { // No Cards for this user

                            setTimeout(() => {
                                this.$emit('handleTitle', 'Add New Card');
                                this.$emit('handleCss', '');
                                this.loading = false;
                                this.triggerCardInput();
                            }, 1000);
                        }
                    } else {
                        window.raw = JSON.stringify(response.status);
                        window.failedFromStart = false;
                        window.failedFromStartMessage = response;
                        this.$router.push('/v2/mtn/warning');
                    }

                }).catch(err => {
                    console.log(err)
                    window.raw = JSON.stringify(err);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = err;
                    this.$router.push('/v2/mtn/warning');
                })
            } catch (err) {
                console.log(`Call OnePipe Error ${err}`)
                window.raw = JSON.stringify(err);
                window.failedFromStart = false;
                window.failedFromStartMessage = err;
                this.$router.push('/v2/mtn/warning');
            }
        },

        gotoCardListing() {
            this.show_select_card = true;
            this.show_manage_card = false;
            this.$emit('handleTitle', this.data.details.title);
            this.$emit('handleCss', 'cardmaster master');

        },
        handleAttemptCardRemoval(key) {
            this.$emit('handleCss', '')
            this.attemptCardRemoval = true,
            this.attemptCardRemovalCardKey = key,
            this.cardToBeRemoved = this.cards[key];
        },

        cancelCardRemoval() {
            this.$emit('handleCss', 'cardmaster')
            this.attemptCardRemoval = false,
            this.attemptCardRemovalCardKey = null,
            this.cardToBeRemoved = {};
        },

        removeCard() {
            let token = this.cardToBeRemoved;
            this.loadingMessage = 'Removing card...'

            try {
                let initialPayload = this.$store.state.payload;
                this.loading = true;

                let payload = {
                    request_ref: this.$generateRequestRef(),
                    request_type: 'remove card',
                    auth: {
                        "type": "custom",
                        "secure": token.uid,
                        "auth_provider": "MPGS",
                    },
                    transaction: {
                        transaction_ref: this.$generateTransactionRef(),
                        transaction_ref_parent: "",
                        customer: initialPayload.transaction.customer
                    }
                }

                let data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'transact',
                    payload: payload
                }
                let data = this.$generateToken(data2);

                axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    Authorization: 'Bearer ' + this.$store.state.payload.api_key
                }).then((response) => {
                    this.loading = false;
                    this.loadingMessage = 'Loading.. please wait';
                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                    window.raw = JSON.stringify(res);

                    if (response.status == 200) {

                        this.attemptCardRemoval = this.loading = false;
                        if (status == "successful") {

                            // Successful style
                            this.removalMessageStyle = {
                                'color': '#3c763d',
                                'background-color': '#dff0d8',
                                'border-color': '#d6e9c6',
                                'padding': '5px',
                                'margin-bottom': '20px',
                                'border': '1px solid transparent',
                                'border-radius': '4px',
                                'text-align': 'center',
                            }

                            const key = this.cards.indexOf(this.cardToBeRemoved);
                            this.cards.splice(key, 1);
                            this.removalMessage = message;

                            if (this.cards.length <= 0) {
                                this.$emit('handleTitle', 'Add New Card');
                                this.$emit('handleCss', '');
                                this.removalMessage = '';
                                this.showCardInput = true;
                                setTimeout(() => {
                                    this.loading = false;
                                    this.triggerCardInput();
                                    this.integration();
                                }, 1000);
                            } else {
                                setTimeout(() => {
                                    this.removalMessage = '';
                                }, 2000);
                            }

                        } else {
                            this.removalMessage = message;
                            setTimeout(() => {
                                this.removalMessage = '';
                            }, 2000);

                        }
                    } else {
                        this.removalMessage = message;
                        setTimeout(() => {
                            this.removalMessage = '';
                        }, 3000);
                    }

                }).catch(err => {
                    this.removalMessage = err;
                    console.log(err)
                    window.raw = JSON.stringify(err);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = err;
                    this.$router.push('/v2/mtn/warning');
                })
            } catch (err) {
                console.log(`Call OnePipe Error ${err}`)
                window.raw = JSON.stringify(err);
                window.failedFromStart = false;
                window.failedFromStartMessage = err;
                this.$router.push('/v2/mtn/warning');
            }

        },

        visitThirdParty(){ // Redirect to other screens
            this.isLoading = true;
            setTimeout(() => {
                this.$parent.in_view= "";
                window.parent.postMessage(JSON.stringify(this.initial_redirect_data), '*');
            },300);
        },

        cancelRedirect(){
            // Generate a new ref
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef(4)}`; 
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            this.$emit('handleTitle', this.data.details.title);
            this.$emit('handleCss', 'cardmaster master');
            this.show_manage_card = false;
            this.show_select_card = true;
            this.showCardInput = false;

            this.redirect_to_third_party=false;

            let el = document.querySelector(`script[src='${this.mpgsSdkUrl}']`);
            if (el) {
                el.remove();
            }

            if(window.countDown)
                clearInterval(window.countDown);

        },

        validate3DS_Transaction(ref){

            
            this.loading = true;

            this.loadingMessage = 'Making Payment...';

            // let initialPayload = this.getInitialPayload(),
            let payload = {
                request_ref: this.$generateRequestRef(),
                request_type: this.$store.state.payload.request_type,
                auth: {
                    secure: ref, // Token,SESSIONid
                    auth_provider: this.provider.provider
                },
                transaction: {
                    transaction_ref: this.$store.state.transRef
                }
            };

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            payload.transaction.transaction_ref = this.$store.state.transRef

            let data2 = {
                    endpoint: 'validate',
                    api_key: this.$store.state.api_key,
                    payload,
                },
                data = this.$generateToken(data2);


                // console.log(JSON.stringify(data2));
            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: 'bearer ' + this.$store.state.payload.api_key
                    }
                }).then(response => {

                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;
                        
                    window.raw = JSON.stringify(res);

                    if (status === "successful") {

                        if(Object.keys(responseData).includes('provider_response') && responseData.provider_response !== null){
                            if(Object.keys(responseData.provider_response).includes('meta') && responseData.provider_response.meta !== null){
                                if(Object.keys(responseData.provider_response.meta).includes('source_of_funds') && responseData.provider_response.meta.source_of_funds !== null){
                                    if(Object.keys(responseData.provider_response.meta.source_of_funds).includes('provided') && responseData.provider_response.meta.source_of_funds.provided !== null){
                                        if(Object.keys(responseData.provider_response.meta.source_of_funds.provided).includes('card') && responseData.provider_response.meta.source_of_funds.provided.card !== null){
                                            const cardUsed = responseData.provider_response.meta.source_of_funds.provided.card;
                                            // Check the the card respsone is present
                                            this.$store.dispatch('mPGSCardUsed', cardUsed);
                                            this.$store.dispatch('paymentMethodProvider', 'MPGS');
                                        }
                                    }
                                }
                            }
                        }


                        this.isLoading = false;
                        this.$parent.changeComponent('Status', {
                            reference: payload.transaction.transaction_ref,
                            type: 'Successful',
                            data: responseData,
                            message: message || res.data.message
                        });

                    } else {
                        window.failedFromStart = false;
                        window.failedFromStartMessage = message || "Payment Failed."
                        this.$router.push('/v2/mtn/warning');
                    }
                    
                })
                .catch(error => {
                    console.log(error)
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })

        },

        timeoutCountdown() {
            window.countDown = setInterval(() => {
                this.countDownSeconds--
                if (this.countDownSeconds <= 0) {
                    clearInterval(window.countDown);
                    this.visitThirdParty();
                    return;
                }
            }, 1000);

        },
    }
}
</script>

<style>
/* .modal.oppay .switch a.left:hover{
    background: transparent !important;
} */

.cardnumb iframe {
    max-width: 100% !important;
    border-right: 1px solid #828282 !important;
    font-family: 'MTNBrighterSans-Regular' !important;
}

.cardnumb iframe html body #number {
    /* max-width: 100px !important; */
    max-width: 95% !important;
    border: none !important;
    font-family: 'MTNBrighterSans-Regular' !important;
}

.cardnumb iframe html body #number::placeholder {
    color: #828282 !important;
    opacity: 1; /* Firefox */
}

.cardnumb iframe html body #number::-ms-input-placeholder {
    color: #828282 !important;
    opacity: 1; /* Firefox */
}

.cardnumb iframe html body #number:-ms-input-placeholder{
    color: #828282 !important;
}



.col-expiry iframe {
    max-width: 100% !important;
    font-family: 'MTNBrighterSans-Regular' !important;
}

.col-expiry iframe html body #expiryMonth,
.col-expiry iframe html body #expiryYear,
.col-expiry.cvv iframe html body #securityCode {
    min-width: 90px !important;
    max-width: 95px !important;
    font-family: 'MTNBrighterSans-Regular' !important;
}

.col-expiry iframe html body #expiryMonth::placeholder,
.col-expiry iframe html body #expiryYear::placeholder,
.col-expiry.cvv iframe html body #securityCode::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #828282 !important;
  opacity: 1; /* Firefox */
}

.col-expiry iframe html body #expiryMonth:-ms-input-placeholder,
.col-expiry iframe html body #expiryYear:-ms-input-placeholder
.col-expiry iframe html body #securityCode:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #828282 !important;
}

.col-expiry iframe html body #expiryMonth::-ms-input-placeholder,
.col-expiry iframe html body #expiryYear:-ms-input-placeholder
.col-expiry iframe html body #securityCode::-ms-input-placeholder { /* MS Edgde 10-11 */
  color: #828282 !important;
}
</style>
